<template>
    <div class="uxo-list">
        <template v-if="hazards.length">
            <div class="column is-full mb-2">
                <button class="btn w-100 mb-2" @click="showSearchFilters()">Filter your search</button>
            </div>
            <div v-for="(hazard) in hazards" class="column is-4-mobile is-4-tablet is-3-desktop mb-2 mb-md-4">
                <a class="uxo-list__item" :href="hazardUrl(hazard)">
                    <div
                        v-if="hazard.images.length > 0"
                        class="uxo-list__item-image-placeholder border-radius"
                        :style="{'background-image' : `url('${hazard.images[0].aws_url}')`}">
                        <img class="image mb-1 d-hidden" :src="hazard.images[0] ? hazard.images[0].aws_url: ''" :alt="hazard.name"/>
                    </div>
                    <div v-else class="uxo-list__item-image-placeholder border-radius"></div>

                    <h5 class="uxo-list__item-title">{{ hazard.name }}</h5>
                </a>
            </div>
        </template>
        <template v-else>
            <div class="empty-search column text-center py-4 py-md-10">
                <h1 class="empty-search__title mb-3">Unfortunately, there are not any results matching your
                    criteria</h1>
                <p class="empty-search__text mb-3">
                    Try again and make your search less specific
                </p>
                <div class="mb-2 d-md-none">
                    <button class="btn w-100" @click="showSearchFilters()">Filter your search</button>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: 'CatUxoList',
        methods: {
            showSearchFilters: function () {
                this.$root.$emit('showSearchFilters');
                this.toggleBodyClass();
            },
            toggleBodyClass() {
                let body = document.body;
                body.classList.add('has-overlay');
            },
            hazardUrl(hazard) {
                return `/explosive-hazards/${hazard.type.slug}/${hazard.slug}`;
            }
        },
        computed: {
            ...mapState('hazards', [
                'hazards',
            ]),
        },
        mounted() {
        }
    }
</script>

<style lang="scss" scoped>
    @media(max-width: 480px) {
        .column {
            width: 50%;
        }
    }

    @media(min-width: 768px) {
        .column.is-full {
            display: none;
        }
    }

    @media (max-width: 560px) {
        .column.is-4-mobile {
            width: 50%;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/uxo/List.vue